export default __webpack_public_path__ + "static/media/sports01.09675cfa.jpg";